import { getCurrentLocale } from 'cadenza/utils/i18n/i18n';

// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { DecimalFormat } from './DecimalFormat';

/*
 * DecimalFormat uses '.' as decimal separator and ',' as grouping separator.
 * This patch adapts this behavior to respect the configured locale.
 */
class PatchedDecimalFormat extends DecimalFormat {

  static get groupingSeparator () {
    return (1000).toLocaleString(getCurrentLocale())[1];
  }

  static get decimalSeparator () {
    return (0.1).toLocaleString(getCurrentLocale())[1];
  }

  override format (value: number | string | null | undefined) {
    if (value === null || value === undefined) {
      return '';
    }
    if (Number.isNaN(value)) {
      return String(value);
    }
    return swapDecimalAndGroupSeparator(super.format(value));
  }

  override formatBack (formattedValue: string | number | null | undefined) {
    if (formattedValue === null || formattedValue === undefined) {
      return '';
    }
    if (typeof formattedValue === 'number') {
      return String(formattedValue);
    }
    return formattedValue
      .replace(new RegExp('\\' + PatchedDecimalFormat.groupingSeparator, 'g'), '')
      .replace(PatchedDecimalFormat.decimalSeparator, '.');
  }

  static getNumberOfDecimals (format: string) {
    if (format.length < 2) {
      return 0; // There's no decimals if the format length is 1
    }
    format = swapDecimalAndGroupSeparator(format);
    const decimalSeparatorPosition = format.indexOf(PatchedDecimalFormat.decimalSeparator);
    if (decimalSeparatorPosition > -1) {
      return format.length - 1 - decimalSeparatorPosition;
    }
    return 0;
  }

}

function swapDecimalAndGroupSeparator (value: string) {
  return value.replace('.', '{decimalSeparator}')
    .replace(/,/g, PatchedDecimalFormat.groupingSeparator)
    .replace('{decimalSeparator}', PatchedDecimalFormat.decimalSeparator);
}

export { PatchedDecimalFormat as DecimalFormat };
